import { CSSProperties } from 'react';

export const getPhoneInputStyles = (height: string, isInvalid: boolean): CSSProperties => ({
  height,
  borderRadius: 0,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: '1px solid',
  borderColor: isInvalid ? '#E53E3E' : '#E2E8F0',
  backgroundColor: 'transparent',
  outline: 'none',
  paddingLeft: '8px',
  paddingRight: '8px',
  fontSize: '15px',
  transition: 'border-color 0.2s',
  direction: 'ltr',
  textAlign: 'left',
});

export const getCountrySelectStyles = (height: string, isInvalid: boolean): CSSProperties => ({
  height,
  borderRadius: 0,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: '1px solid',
  borderColor: isInvalid ? '#E53E3E' : '#E2E8F0',
  backgroundColor: 'transparent',
  outline: 'none',
  fontSize: '13px',
  marginRight: '4px',
  marginLeft: '0',
});

export const DEFAULT_CONFIG = {
  width: '100%',
  height: '40px',
  defaultCountry: 'UA' as const,
} as const;
